import Cta from '../../fragments/cta/Cta';
import Button from '../../fragments/button/Button';
import Icon from '../../fragments/icon/Icon';

import { SmartLink } from '../../fragments/smart-link/SmartLink';
import { Fragment, useMemo } from 'react';

// import Image from 'next/image';
// import image from '../../../assets/images/footer-logo.svg';

export default function Row1({ block, onLinkEnter, onNavLeave }) {
  const columns = block.menu.slice(0, 3);

  // Per-column running offset so each link gets a unique global index
  // matching its slot in the hover-image stack.
  const offsets = useMemo(() => {
    let n = 0;
    return columns.map((c) => {
      const o = n;
      n += c.children?.length || 0;
      return o;
    });
  }, [block.menu]);

  return (
    // <div className="NavigationFooter-row">
    <nav
      className="NavigationFooter-nav"
      aria-label={block.menuLabel || ''}
      onMouseLeave={onNavLeave}
    >
      {columns.map((menu, i) => (
        <div className="NavigationFooter-navItem" key={i}>
          {/* <p className="NavigationFooter-navHeading text--size-s headingStrong">
            {menu.label}
          </p> */}
          <Button
            buttonLabel={menu.label}
            theme="underline"
            size="regular"
            icon={false}
            disabled
          />
          {menu.children?.length > 0 && (
            <ul className="NavigationFooter-navList">
              {menu.children.map((item, index) => (
                <li
                  key={index}
                  className="text--size-s"
                  onMouseEnter={
                    onLinkEnter
                      ? () => onLinkEnter(offsets[i] + index)
                      : undefined
                  }
                >
                  <Cta
                    cta={{ url: item.uri, buttonLabel: item.label }}
                    theme="underline"
                    icon={false}
                  />
                  {/* <SmartLink href={item.uri}>{item.label}</SmartLink> */}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </nav>
    // </div>
  );
}
